import gsap from 'gsap'
import Detect from '../lib/Detect'
const detect = Detect.getInstance()

/**
 * data-parallaxをdomにセット
 * data-parallax-depth: 重さ
 * data-parallax-rev: -1をセットで進行方向反対
 */
class Parallax {
  constructor(trigger, debug=false) {
    this.trigger = trigger
    this.els = gsap.utils.toArray(this.trigger.querySelectorAll("[data-parallax]"))
    this.tl = gsap.timeline({
      scrollTrigger: {
        id: 'Parallax',
        trigger: this.trigger,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        markers: debug,
      }
    });
    this.init()
  }

  init () {
   this.els.forEach(el => {
      const src = el.src
      if (src) {
        const img = new Image()
        img.addEventListener("load", () => {
          this.setAnim(el)
        }, false)
        img.src = src
      } else {
        this.setAnim(el)
      }
    });
  }

  setAnim(layer) {

    const canSp = layer.dataset.parallaxSp
    // if (!detect.isPc() && !canSp) {
    //   return
    // }

    const depth = layer.dataset.parallaxDepth
    const rev = layer.dataset.parallaxRev || 1
    const end = layer.dataset.parallaxEnd || 1

    // const movement = -(layer.offsetHeight * depth)
    // this.tl.to(layer, {y: movement, ease: "none"}, 0)

    const movement = layer.offsetHeight * depth
    this.tl.fromTo(layer, {
      y: movement*rev,
    }, {
      y: -movement*rev*end,
      ease: "none"
    }, 0)
  }

}

export default Parallax